import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
import { FadeInUp } from './FadeInUp';
import { ShimmerButton } from './ShimmerButton';
interface OfferCardProps {
  onCtaClick: () => void;
}
export function OfferCard({
  onCtaClick
}: OfferCardProps) {
  const benefits = ['Acceso de por vida al protocolo', 'Actualizaciones gratis para siempre', 'Bonus: Checklist de Salud Mental Canina'];
  return <section className="py-24 px-5 pt-[20px] pb-[20px]" data-id="element-79">
      <FadeInUp className="max-w-lg mx-auto bg-white rounded-3xl border-2 border-slate-dark shadow-2xl overflow-hidden relative" data-id="element-80">
        <div className="bg-pistachio text-slate-dark text-center py-3 font-bold tracking-wider text-sm" data-id="element-81">
          OFERTA DE LANZAMIENTO
        </div>

        <div className="p-8 md:p-12 text-center" data-id="element-82">
          <div className="mb-8" data-id="element-83">
            <span className="text-slate-dark/40 line-through text-xl font-medium block mb-2" data-id="element-84">
              Precio normal: $24.990
            </span>
            <div className="text-6xl font-serif font-bold text-slate-dark" data-id="element-85">
              $4.990{' '}
            </div>
          </div>

          <div className="space-y-4 mb-10 text-left" data-id="element-86">
            {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-3" data-id="element-87">
                <CheckCircleIcon className="w-6 h-6 text-pistachio shrink-0" data-id="element-88" />
                <span className="text-slate-dark font-medium" data-id="element-89">{benefit}</span>
              </div>)}
          </div>

          <ShimmerButton onClick={onCtaClick} className="w-full text-lg mb-8" data-id="element-90">
            DESCARGAR TODO AHORA
          </ShimmerButton>

           <div className="flex justify-center items-center text-slate-dark/40 text-sm font-medium grayscale opacity-70 gap-[3px]" data-id="element-91">
            
            
            <span data-id="element-92">Pago único</span>
            <span data-id="element-93">•</span>
            <span data-id="element-94">Entrega inmediata</span>
          </div>

          <div className="flex justify-center items-center text-slate-dark/40 text-sm font-medium grayscale opacity-70 gap-[3px]" data-id="element-95">
            
            
            <span data-id="element-96">MERCADOPAGO</span>
            <span data-id="element-97">•</span>
            <span data-id="element-98">TRANSFERENCIA</span>
          </div>
        </div>
      </FadeInUp>
    </section>;
}